import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updatePhotoSessionAdvancedSurveys = async ({ sessionId, stepId, surveys }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const res = await axios.put(
    `${__API_URL__}/api/survey/photo-sessions/${sessionId}/advanced-surveys/?${params.toString()}`,
    { surveys },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdatePhotoSessionAdvancedSurveysMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePhotoSessionAdvancedSurveys,
    onSuccess: (_, variables) => {
      toast.success("Session surveys updated");
      queryClient.invalidateQueries({
        queryKey: ["photo_session_advanced_surveys", variables.sessionId],
      });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update session surveys");
    },
  });
};

export default useUpdatePhotoSessionAdvancedSurveysMutation;
